import { Input } from "~/components/ui/input";
import { Button } from "~/components/ui/button";
import { Search } from "lucide-react";
import { router } from "@inertiajs/react";
import { useRef } from "react";

export default function () {
  if (import.meta.env.SSR) return null;

  const params = new URLSearchParams(document.location.search);
  const query = params.get("q") || "";

  const serachInputRef = useRef();

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      search(e.target.value);
    }
  };

  const handleSearchButtonClick = () => {
    search(serachInputRef.current.value);
  };

  const search = (value) => {
    params.set("q", value);
    router.visit(`/t/categories/roznichnyi-sait?${params.toString()}`);
  };

  return (
    <div className="flex items-center relative ">
      <Input
        placeholder="Поиск ..."
        className="shadow-none bg-gray-50 py-5 lg:w-[300px] w-full"
        onKeyDown={handleKeyDown}
        defaultValue={query}
        ref={serachInputRef}
      />
      <div className="absolute inset-y-1 right-1">
        <Button
          _variant="secondary"
          size="md"
          onClick={handleSearchButtonClick}
        >
          <Search />
        </Button>
      </div>
    </div>
  );
}
